import React from 'react'

import css from '@styled-system/css'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import IconBase, { Path } from '../IconBase/IconBase'

const directions = ({ isRtl } = {}) => ({
  left: isRtl ? 0 : 180,
  right: isRtl ? 180 : 0,
})

const PaperPlaneBox = styled(IconBase)(
  ({ $direction, isVisible = true, theme: { isRtl } }) =>
    css({
      svg: {
        transition: '0.5s',
        opacity: isVisible ? 1 : 0,
        transform: `rotate(${directions({ isRtl })?.[$direction] ?? 0}deg)`,
      },
    }),
)

function PaperPlane({
  color = 'icon.primary',
  fill = 'transparent',
  direction = 'right',
  ...props
}) {
  return (
    <PaperPlaneBox viewBox='0 0 12 12' $direction={direction} {...props}>
      <Path
        d='M5.34047 6.00126L2.10938 6.00126'
        stroke={color}
        fill={fill}
        strokeWidth='1'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2.02449 1.07477
        L10.6112 5.36701
        C10.851 5.48684 11.0025 5.73191 11.0025 6
        C11.0025 6.26809 10.851 6.51316 10.6112 6.63299
        L2.02449 10.9252
        C1.77567 11.0497 1.47703 11.0168 1.26121 10.8413
        C1.04539 10.6657 0.952414 10.38 1.02358 10.1111
        L2.11249 6
        L1.02358 1.88892
        C0.952414 1.61998 1.04539 1.33428 1.26121 1.15873
        C1.47703 0.983178 1.77567 0.950326 2.02449 1.07477'
        stroke={color}
        fill={fill}
        strokeWidth='1'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </PaperPlaneBox>
  )
}

PaperPlane.propTypes = {
  direction: PropTypes.oneOf(['left', 'right']),
  color: PropTypes.string,
  fill: PropTypes.string,
  strokeWidth: PropTypes.string,
}

export default PaperPlane
